import { Form } from '../../../../../models/form-builder/form.model';
import { FormFieldCascadingDropdownConstraint } from '../../../../../models/form-builder/field-constraints/field-cascading-dropdown-constraint.model';
import { ISiteFormFieldConstraints } from './isite-form-field-constraints.interface';
import { SiteConstraintsBase } from './site-constraints-base';
import { CachedFormFieldService } from '../../../../../services/form-field-with-cache.service';
import { IFormFieldConstraintLiaison } from './ifield-constraint-liason.interface';
import { FormFieldCascadingDropdownConstraintLiaison } from './field-cascading-dropdown-constraint-liaison';

export class SiteCascadingDropdowns extends SiteConstraintsBase implements ISiteFormFieldConstraints {
    // Constructor.
    public constructor(private form: Form, cachedFormFieldServiceParam: CachedFormFieldService) {
        super(new FormFieldCascadingDropdownConstraintLiaison(), form, cachedFormFieldServiceParam);
    }
}
